

import React, { useState, useRef } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Col, Row, Container } from "react-bootstrap";
// New package button
import { Button } from '@veeyaainnovatives/button';
import { Banner } from '@veeyaainnovatives/banner';
import axios from 'axios';
import { getApiUrl } from '../config/api';

import Form from 'react-bootstrap/Form';
import Bannerimg from '../assets/images/gallery/gallery-3.jpg';

const Careers = () => {

    const pageDetails = {
        title: "We are **Hiring**",
        description: "We are always seeking talented, highly motivated individuals who are willing to take on responsibility and grow with our team. We encourage people interested in architecture, interior design, construction, and carpentry to contact us. ",
        breadcrumb: [
            { name: "Home", link: "/" },
            { name: "Careers", link: "/careers" }
        ],
    }


    const [dragActive, setDragActive] = useState(false);
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobileNumber: "",
        position: "",
        moreAboutYou: "",
        resume: null
    });

    const [errors, setErrors] = useState({});
    const allowedTypes = [
        "application/pdf",
        "application/msword", // .doc
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document" // .docx
    ];

    const handleChangeInput = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });

        setErrors({
            ...errors,
            [e.target.name]: ""
        });
    };

    // VALIDATION
    const validateForm = () => {
        let newErrors = {};

        if (!formData.name.trim()) newErrors.name = "Full name is required";
        if (!formData.email.trim()) newErrors.email = "Email is required";
        else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Enter a valid email";

        if (!formData.mobileNumber.trim()) newErrors.mobileNumber = "Mobile number is required";
        else if (!/^[0-9]{10}$/.test(formData.mobileNumber))
            newErrors.mobileNumber = "Enter a valid 10-digit number";

        if (!formData.position.trim()) newErrors.position = "Position applied for is required";

        if (files.length === 0) {
            newErrors.resume = "Resume is required";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!validateForm()) {
            toast.error("Please fix the errors");
            return;
        }

        setIsSubmitting(true);

        try {
            // Create FormData for file upload
            const formDataToSend = new FormData();
            
            // Map form fields to API expected format
            formDataToSend.append('full_name', formData.name);
            formDataToSend.append('email', formData.email);
            formDataToSend.append('mobile_number', formData.mobileNumber);
            formDataToSend.append('position_applied_for', formData.position);
            
            // Optional field
            if (formData.moreAboutYou) {
                formDataToSend.append('more_about_you', formData.moreAboutYou);
            }

            // Append resume file (only one file allowed)
            if (files.length > 0) {
                formDataToSend.append('resume', files[0]);
            }

            // Make API call
            const response = await axios.post(
                getApiUrl('api/public/career'),
                formDataToSend,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                }
            );

            if (response.data.success) {
                toast.success(response.data.message || "Application submitted successfully. We will contact you shortly.");
                
                // Reset form
                setFormData({
                    name: "",
                    email: "",
                    mobileNumber: "",
                    position: "",
                    moreAboutYou: "",
                    resume: null
                });
                setFiles([]);
                setErrors({});
                
                // Reset file input
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            } else {
                toast.error(response.data.message || "Failed to submit application");
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            
            // Handle validation errors
            if (error.response && error.response.data && error.response.data.errors) {
                const apiErrors = error.response.data.errors;
                const newErrors = {};
                
                // Map API error keys to form field names
                Object.keys(apiErrors).forEach(key => {
                    if (key === 'mobile_number') {
                        newErrors.mobileNumber = apiErrors[key][0];
                    } else if (key === 'position_applied_for') {
                        newErrors.position = apiErrors[key][0];
                    } else if (key === 'full_name') {
                        newErrors.name = apiErrors[key][0];
                    } else if (key === 'more_about_you') {
                        newErrors.moreAboutYou = apiErrors[key][0];
                    } else {
                        newErrors[key] = apiErrors[key][0];
                    }
                });
                
                setErrors(newErrors);
                toast.error(error.response.data.message || "Validation error. Please check the form.");
            } else {
                toast.error(error.response?.data?.message || "Failed to submit application. Please try again.");
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    // File handling
    const addFile = (incomingFile) => {
        if (files.length > 0) {
            toast.warning("Only one resume file is allowed. Please remove the existing file first.");
            return;
        }

        if (allowedTypes.includes(incomingFile.type)) {
            setFiles([incomingFile]);
            setFormData(prev => ({ ...prev, resume: incomingFile }));
            setErrors(prev => ({ ...prev, resume: "" }));
        } else {
            toast.error(`Invalid file type: ${incomingFile.name}. Only PDF, DOC, DOCX allowed.`);
        }
    };

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.type === "dragenter" || e.type === "dragover") {
            setDragActive(true);
        } else if (e.type === "dragleave") {
            setDragActive(false);
        }
    };

    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragActive(false);
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
            addFile(e.dataTransfer.files[0]);
        }
    };

    const handleFileInputChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            addFile(e.target.files[0]);
        }
    };

    const removeFile = () => {
        setFiles([]);
        setFormData(prev => ({ ...prev, resume: null }));
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    const handleDivClick = () => {
        fileInputRef.current?.click();
    };


    return (
        <>
            <Banner img={Bannerimg} pageDetails={pageDetails} highlightClassName="theme-color-green" />
            <div className="body-wrap overflow-hidden mt-5">
                {/* our works */}
                <section className='py-4'>
                    <div className="position-relative">
                        <div className="design-circle-our-worksection position-absolute"></div>
                        <Container className="mb-5" >

                            <Row>
                                <Col lg={8} className="mx-auto">
                                    <form noValidate onSubmit={handleSubmit}>

                                        <Row>
                                            {/* NAME */}
                                            <Col lg={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Control
                                                        type="text"
                                                        name="name"
                                                        placeholder="Full Name"
                                                        value={formData.name}
                                                        onChange={handleChangeInput}
                                                        className={errors.name ? "is-invalid" : ""}
                                                    />
                                                    {errors.name && <span className="text-danger ms-3">{errors.name}</span>}
                                                </Form.Group>
                                            </Col>

                                            {/* EMAIL */}
                                            <Col lg={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Control
                                                        type="email"
                                                        name="email"
                                                        placeholder="Email"
                                                        value={formData.email}
                                                        onChange={handleChangeInput}
                                                        className={errors.email ? "is-invalid" : ""}
                                                    />
                                                    {errors.email && <span className="text-danger ms-3">{errors.email}</span>}
                                                </Form.Group>
                                            </Col>

                                            {/* MOBILE */}
                                            <Col lg={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Control
                                                        type="text"
                                                        name="mobileNumber"
                                                        placeholder="Mobile Number"
                                                        value={formData.mobileNumber}
                                                        onChange={handleChangeInput}
                                                        className={errors.mobileNumber ? "is-invalid" : ""}
                                                    />
                                                    {errors.mobileNumber && <span className="text-danger ms-3">{errors.mobileNumber}</span>}
                                                </Form.Group>
                                            </Col>


                                            <Col lg={6}>
                                                <Form.Group className="mb-3">
                                                    <Form.Control
                                                        type="text"
                                                        name="position"
                                                        placeholder="Position Applied For"
                                                        value={formData.position}
                                                        onChange={handleChangeInput}
                                                        className={errors.position ? "is-invalid" : ""}
                                                    />
                                                    {errors.position && <span className="text-danger ms-3">{errors.position}</span>}
                                                </Form.Group>
                                            </Col>

                                        </Row>

                                        {/* MORE ABOUT YOU */}
                                        <Form.Group className="mb-3">
                                            <Form.Control
                                                as="textarea"
                                                rows={4}
                                                name="moreAboutYou"
                                                placeholder="More about you..."
                                                value={formData.moreAboutYou}
                                                onChange={handleChangeInput}
                                                className={errors.moreAboutYou ? "is-invalid" : ""}
                                            />
                                            {errors.moreAboutYou && <span className="text-danger ms-3">{errors.moreAboutYou}</span>}
                                        </Form.Group>

                                        {/* FILE UPLOAD */}
                                        <Form.Group className="mb-4">
                                            <div
                                                className={`file-upload-drop-zone ${dragActive ? 'active' : ''} ${errors.resume ? 'is-invalid' : ''}`}
                                                onDragEnter={handleDrag}
                                                onDragLeave={handleDrag}
                                                onDragOver={handleDrag}
                                                onDrop={handleDrop}
                                                onClick={handleDivClick}
                                            >
                                                <h5 className="file-upload-section-title">Upload your Resume (PDF, DOC, DOCX only)</h5>
                                                <input
                                                    type="file"
                                                    ref={fileInputRef}
                                                    id="fileInput"
                                                    accept=".pdf,.doc,.docx"
                                                    onChange={handleFileInputChange}
                                                    className="file-input-hidden"
                                                />
                                                <label htmlFor="fileInput" className="file-upload-label">
                                                    <p className="upload-text">Drop or click to browse files</p>
                                                </label>
                                            </div>
                                            {errors.resume && <span className="text-danger ms-3">{errors.resume}</span>}
                                        </Form.Group>

                                        {files.length > 0 && (
                                            <div className="mb-4 uploaded-files-list">
                                                <h5 className="uploaded-files-title">Uploaded Resume</h5>
                                                {files.map((file, i) => (
                                                    <div key={i} className="uploaded-file-item">
                                                        <span>{file.name}</span>
                                                        <button
                                                            type="button"
                                                            onClick={removeFile}
                                                            className="remove-file-btn"
                                                        >
                                                            ✕
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        )}

                                        <Button 
                                            type="submit" 
                                            className="btn-block-green h-56px mt-md-3"
                                            backgroundColor="#677a58"
                                            color="#ffffff"
                                            hoverBackgroundColor="#5a6a4a"
                                            height="56px"
                                            disabled={isSubmitting}
                                        >
                                            {isSubmitting ? "Submitting..." : "Submit"}
                                        </Button>
                                    </form>

                                </Col>
                            </Row>

                            {/* Toast */}
                            <ToastContainer theme="colored" />


                        </Container>

                    </div>
                </section>
            </div>
        </>

    )
}

export default Careers;